/**
 * Shared pricing data — single source of truth for landing page and premium tab
 */

export const PRICING = {
  master: {
    monthly: 9.99,
    annual: 99,
    platformFee: '10%',
  },
  grandmaster: {
    monthly: 29.99,
    annual: 299,
    platformFee: '5%',
  },
};

/**
 * Comparison table rows used by PricingComparison (landing) and PremiumTabForm (dashboard)
 * Each row: { feature, free, master, grandmaster }
 *   - string values render as text
 *   - true renders a checkmark
 *   - false / null renders a dash
 *   - 'double-check' renders double checkmarks (Grandmaster priority support)
 */
export const COMPARISON_ROWS = [
  {
    feature: 'Domain',
    free: 'chessweb.site/me/name',
    master: 'name.chessweb.site or Custom',
    grandmaster: 'name.chessweb.site or Custom',
  },
  {
    feature: 'Custom Website Builder',
    free: false,
    master: true,
    grandmaster: true,
  },
  {
    feature: 'Coaching Academy',
    free: false,
    master: true,
    grandmaster: true,
  },
  {
    feature: 'Online Shop',
    free: false,
    master: true,
    grandmaster: true,
  },
  {
    feature: 'Content Library',
    free: false,
    master: true,
    grandmaster: true,
  },
  {
    feature: 'Blogs',
    free: '2',
    master: 'Unlimited',
    grandmaster: 'Unlimited',
  },
  {
    feature: 'Analytics & Sales Funnels',
    free: false,
    master: true,
    grandmaster: true,
  },
  {
    feature: 'Platform Fee on Transactions',
    free: false,
    master: '10%',
    grandmaster: '5%',
  },
  {
    feature: 'Donation Fees',
    free: false,
    master: '0%',
    grandmaster: '0%',
  },
  {
    feature: 'Priority Support',
    free: false,
    master: true,
    grandmaster: 'double-check',
  },
];

export const PRODUCT_CARDS = [
  {
    icon: 'fa-globe',
    title: 'Custom Domain & Builder',
    description: 'Unlock your custom subdomain and the full visual page builder.',
    features: [
      'Drag-and-drop block editor',
      'Custom subdomain (you.chessweb.site)',
      'Mobile-responsive themes',
    ],
  },
  {
    icon: 'fa-book-open',
    title: 'Content Library',
    description: 'Upload PGNs, videos, PDFs, and interactive puzzles for your students.',
    features: [
      'Organize with folders & access control',
      'Upload files up to 3 GB',
      'Sell courses through your shop',
    ],
  },
  {
    icon: 'fa-chalkboard-user',
    title: 'Academy Management',
    description: 'Run group classes with scheduling, payments, and student management.',
    features: [
      'Integrated Stripe payments',
      'Student credit system',
      'Email & in-app notifications',
    ],
  },
  {
    icon: 'fa-tags',
    title: 'Set Your Own Prices',
    description: 'Monetize coaching, courses, and merchandise — you keep the majority.',
    features: [
      'Online shop with Stripe Connect',
      'Donation page for supporters',
      'Transparent, low platform fees',
    ],
  },
];
